<nav class="navbar navbar-expand-md navbar-light bg-primary navbar-login">
  <div class="container">
    <a class="navbar-brand" href="#" data-test="navbarBrand">
      <img
        [src]="environment.customerAssetsDir + 'img/' + environment.images.loginLogoNavbar"
        [alt]="environment.appName"
      />
    </a>
  </div>
</nav>

<div
  class="top-image"
  [style.background-image]="'url(' + environment.customerAssetsDir + 'img/' + environment.images.loginBackground + ')'"
>
  <div class="container container-padding-y">
    <div class="row login-row">
      <div class="col-12 offset-lg-3 col-lg-6 offset-xl-4 col-xl-4">
        <cfp-login-page />
      </div>
    </div>
    <div class="row login-cards-row">
      <div class="col-12 col-lg-4">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="d-flex align-items-center">
              <img class="me-3" src="assets/styling/img/icons/tree.svg" /> Sustainability measures
            </h4>
            <p class="m-0">Reduce your energy costs by applying suggested energy-efficiency measures.</p>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="d-flex align-items-center">
              <img class="me-3" src="assets/styling/img/icons/pie-chart.svg" /> Insight into EPCs
            </h4>
            <p class="m-0">
              An overview of the current status of your buildings and the possible improvements to the EPC ratings.
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="d-flex align-items-center">
              <img class="me-3" src="assets/styling/img/icons/real-estate.svg" /> Portfolio overview
            </h4>
            <p class="m-0">All your buildings and the energy-efficiency potential together in one table.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container container-padding-y container-padding-x">
  <div class="row">
    <div class="col-12">
      <h2>{{ environment.appName }}</h2>
      <p>
        Making the built environment more sustainable is an important task to achieve climate objectives, but can also
        be lucrative for your business at the same time. You can lower your energy bill by implementing
        energy-efficiency measures, and, for example, installing solar PV panels on your roof will generate your own
        renewable energy. Working towards a future-proof building and complying with legislation and regulations can go
        hand in hand.

        {{ environment.customerName }} wants to help customers transition to a more sustainable and future-proof built
        environment. We are helping customers make their first steps into making their buildings more sustainable via
        this free insight tool.
      </p>
    </div>
  </div>
</div>

<div class="bottom-cards"></div>

<cfp-login-footer />
